import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientItem } from 'src/app/model/client-item';
import { CoverageItem } from 'src/app/model/coverage-item';
import { DeviceType } from 'src/app/model/device-type';
import { QuestionSetItem } from 'src/app/model/questionset-item';
import { RegisterDevice } from 'src/app/model/register-device';
import { RegisterItem } from 'src/app/model/register-item';
import { CommonService } from 'src/app/services/common.service';
import { ExternalService } from 'src/app/services/external.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { StorageService } from 'src/app/services/storage.service';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { RequestIntegrationItem } from '../../model/client-policy-detail';
import { RegisteredDeviceItem, CoverageItemPolicy, PolicyDetailItem } from 'src/app/model/policy-detail-item';
import { CertificateItem } from 'src/app/model/certificate-item';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-service-page',
  templateUrl: './service-page.component.html',
  styleUrls: ['./service-page.component.scss']
})
export class ServicePageComponent implements OnInit {
  tabs: any[] = ["Datos personales", "Dirección", "Datos del servicio", "Validación de servicio"];
  @ViewChild('stepper') stepper!: MatStepper;
  faArrowLeft = faArrowLeft
  currentTab: any = -1;
  device!: RequestIntegrationItem;
  firstFormGroup!: FormGroup;
  today:Date = new Date()
  loading:boolean=false
  
  clientItems!: RequestIntegrationItem[];
  msspItem!:CoverageItemPolicy;
  questionItem!:QuestionSetItem;
  serviceDataForm!:FormGroup;

  constructor(
    private storageService: StorageService,
    private commonService: CommonService,
    private mssService:MSSPService,
    private route:ActivatedRoute,
    private router: Router,
    public translate: TranslateService

    ) {
      this.commonService.deviceId = this.route.snapshot.params['deviceId']
      this.commonService.policy = this.storageService.getData('policy')
      this.commonService.certificate = this.storageService.getData('certificado')
      this.commonService.idCliente = this.storageService.getData('idClient')
      this.commonService.apikey = this.storageService.getData('apiKey')
      this.commonService.client = this.storageService.getData('client')
      this.commonService.risk = this.storageService.getData('risk')
      this.commonService.session = this.storageService.getData('sessionId');
      this.commonService.dealerCode ||= this.storageService.getData('dealerCode');
    }

  ngOnInit(): void {
    this.loading = true

    if (typeof this.commonService.reqClientData !== 'undefined' && typeof this.commonService.reqMsspData !== undefined) {
      // ToDo modificar a variable de servicio
      // this.clientItems = this.commonService.capitalLetter(reqClient.data.RequestIntegration)
      this.clientItems = this.commonService.capitalLetter(this.commonService.reqClientData.RequestIntegration);
      // this.msspItem = reqMssp.data.Coverages.find(this.commonService.typeValidation)
      const msspItemCoverage = this.commonService.reqMsspData.Coverages.find(this.commonService.typeValidation);
      if (typeof msspItemCoverage !== 'undefined') {
        this.msspItem = msspItemCoverage
      }
      let oneDev = this.clientItems.find(el => el.SRNumber === this.commonService.deviceId)
      if (oneDev) {
        this.device = oneDev
        var itemDesc = this.device.Abstract.slice(0, this.device.Abstract.indexOf("[")).trim()
        itemDesc = itemDesc.replace('"','')
        // var msspRegisterItem = this.findDevice(reqMssp.data.ItemInfo[0].RegisteredDevices, this.device.SRNumber)
        if (!this.commonService.isMultipleCertificate) {
          const msspRegisterItem = this.findDevice(this.commonService.reqMsspData.ItemInfo[0].RegisteredDevices, this.device.SRNumber)
          if (msspRegisterItem === null) {
            this.mssService.productService().subscribe((res) => {
              if(res.data)
                this.firstRegisterItem(this.device, itemDesc, res.data)
            })
          } else {
            this.loading = false;
          }
        } else {
          this.mssService.getPolicy(this.commonService.policy, this.commonService.idCliente, this.commonService.certificate, this.commonService.isMultipleCertificate, this.commonService.dealerCode, 'array').subscribe(response => {
            let certificates = response.data as Array<CertificateItem>;
            let removedCertificates: Array<CertificateItem> = [];
            let certificatesDetail: Array<PolicyDetailItem> = [];
            let certificateNumber: string|null = null;            
            
            const today = new Date();
            const nearestCertificates = certificates.filter((cert, i) => {

              const warrantyDate = new Date(cert.ItemExpirationDate);

              if (warrantyDate.getTime() >= today.getTime()) {
                return true;
              } else {
                return false;
              }
            }).sort((certA, certB) => {

              const certAExpDate: Date = new Date(certA.ItemExpirationDate);
              const certBExpDate: Date = new Date(certB.ItemExpirationDate);

              if (certAExpDate.getTime() > certBExpDate.getTime())
                return -1
              else
                return 0
            });

            
            const registerItemMultipleCertificates = (): void => {
              this.mssService.productService().subscribe(respPS => {
                if (respPS.data) {
                  this.firstRegisterItem(this.device, itemDesc, respPS.data);
                }
              })
            }

            const getCertificateDetail = ():void => {
              if (nearestCertificates.length > 0) {
                const detail = nearestCertificates.splice(0, 1)[0];
                removedCertificates.push(detail);
                this.mssService.getDetails(this.commonService.idCliente, detail.CertificateNumber, this.commonService.dealerCode, this.commonService.deviceId, this.commonService.policy).subscribe(respDetail => {
                  certificatesDetail.push(respDetail.data);
                  setTimeout(getCertificateDetail, 0);
                })
              } else {

                // ************************************CODIGO DE PRUEBA*********************************

                // certificatesDetail.every((val, ind) => {
                //   val.ItemInfo[0].RegisteredDevices = [];
                //   return val;
                // })

                // removedCertificates[removedCertificates.length - 1].WarrantySalesDate = '2023-09-15T00:00:00';

                // **********************************REMOVER AL TERMINAR LAS PRUEBAS****************************************************

                for (let i = 0; i < certificatesDetail.length; i++) {
                  const detailCert = certificatesDetail[i];
                  const isRegisteredDevice = detailCert.ItemInfo[0].RegisteredDevices.some(d => d.SerialNumber === this.commonService.deviceId || d.RegisteredDeviceName === this.commonService.deviceId);
                  if (isRegisteredDevice) {
                    certificateNumber = detailCert.CertificateNumber;
                    break;
                  }
                }

                this.commonService.certificate =  (certificateNumber === null) ? removedCertificates[0].CertificateNumber : certificateNumber;

                if (certificateNumber === null) {
                  registerItemMultipleCertificates();
                } else {
                  this.loading = false;
                }
              }
            }

            if (nearestCertificates.length > 0) {
              getCertificateDetail();
            } else {
              this.loading = false;
              this.commonService.certificate = '1';
              registerItemMultipleCertificates();
            }
          })
        }
        
      }
    } else {
      const token = this.storageService.getData('encodedToken');
      this.router.navigate(['/'], {queryParams: {q: token}});
    }

    // this.commonService.getlistProducts(this.commonService.policy, this.commonService.idCliente, this.commonService.apikey, this.commonService.client, this.commonService.certificate,  '1234')
    //   .subscribe(({ reqClient, reqMssp }) => {
    //     if (reqClient.data && reqMssp.data) {
    //       this.loading = false
    //       // ToDo modificar a variable de servicio
    //       this.clientItems = this.commonService.capitalLetter(reqClient.data.RequestIntegration)
    //       this.msspItem = reqMssp.data.Coverages.find(this.commonService.typeValidation)
    //       var oneDev = this.clientItems.find(el => el.SRNumber === this.commonService.deviceId)
    //       if (oneDev) {
    //         this.device = oneDev
    //         var itemDesc = this.device.Abstract.slice(0, this.device.Abstract.indexOf("[")).trim()
    //         itemDesc = itemDesc.replace('"','')
    //         var msspRegisterItem = this.findDevice(reqMssp.data.ItemInfo[0].RegisteredDevices, this.device.SRNumber)
    //         if (msspRegisterItem === null) {
    //           this.mssService.productService().subscribe((res) => {
    //             if(res.data)
    //               this.firstRegisterItem(this.device, itemDesc, res.data)
    //           })
    //         }
    //       }
    //     }

    // })

  }

  firstRegisterItem(device:RequestIntegrationItem, itemDesc:string, deviceTypes:DeviceType[] ):void{
    var deviceCode = this.findDeviceTypeCode(deviceTypes, device.SubArea)
    if (deviceCode){
      var registerItem = new RegisterItem(
        this.commonService.idCliente,
        this.commonService.certificate, 
        deviceCode.DeviceTypeCode,
        itemDesc,
        device.R3Idproveedor,
        device.SubArea, 
        device.ContactEmail.toString(),
        device.R3Fechaservicio,
        device.SRNumber,
        '', 
        "0", 
        this.commonService.deviceId,
        device.R3Fechaservicio,
        this.commonService.policy,
        this.commonService.dealerCode,
        this.commonService.companyCode
      )
      this.mssService.registerItem(registerItem).subscribe(
        {
          next: (res: any) => {
            this.loading = false;
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
          } 
        }
      )
    }

  }

  findDevice(registerDevices:RegisteredDeviceItem[], serialNumber:string):RegisteredDeviceItem | null{
    if(registerDevices.length != 0){
      var registerDev = registerDevices.find(res => res.SerialNumber == serialNumber || res.RegisteredDeviceName == serialNumber)
     
      if(registerDev) return registerDev
    }
    return null
  }

  findDeviceTypeCode(deviceTypes:DeviceType[], subArea:string):DeviceType | null {
    if (deviceTypes.length != 0) {
      if (subArea == "Plancha") return new DeviceType('SMAPP','Electrodoméstico')
      var deviceCode = deviceTypes.find(res => res.DeviceTypeDescription === subArea)
      if (deviceCode) return deviceCode
    }
    return new DeviceType('SMAPP','Electrodoméstico')
  }

  stepBack(step: any):void {
    if(this.currentTab > -1){
      this.currentTab--;
      this.stepper.previous();
      return 
    } else {
      const token = this.storageService.getData('encodedToken');
      this.router.navigate(['/'], {queryParams: {q: token}});
    }
  }
  stepOn(form:any){
    if(form.valid && this.currentTab != 3){
      this.firstFormGroup = form;
      this.currentTab++;
      this.stepper.next();
    }
  }

  getItem(question:any){
    this.questionItem = question
  }

  getServiceDataForm(form:any){
    this.serviceDataForm = form
  }
}
